var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformacionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1440_500)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    d: "M0.714748 19H22.2853C22.6813 19 23 18.6928 23 18.311V3.65186C23 3.27002 22.6813 2.96283 22.2853 2.96283H16.4988V0.68903C16.4988 0.307193 16.1801 0 15.784 0H9.87841C9.48232 0 9.16367 0.307193 9.16367 0.68903V2.96283H6.56973V2.6987C6.56973 2.31686 6.25107 2.00967 5.85498 2.00967H3.85368C3.46057 2.00967 3.13894 2.31686 3.13894 2.6987V2.96283H0.714748C0.318659 2.96283 0 3.27002 0 3.65186V18.311C0 18.6928 0.318659 19 0.714748 19ZM10.5932 1.37806H15.0693V2.96283H10.5932V1.37806ZM1.4295 4.34089H9.87841H15.784H21.5705V17.6219H1.4295V4.34089Z",
    fill: "#0985C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    d: "M14.6732 5.72467C11.6355 5.72467 9.1637 8.10756 9.1637 11.0359C9.1637 13.9643 11.6355 16.3472 14.6732 16.3472C17.7109 16.3472 20.1827 13.9643 20.1827 11.0359C20.1857 8.10756 17.7139 5.72467 14.6732 5.72467ZM14.6732 14.972C12.4247 14.972 10.5932 13.2064 10.5932 11.0388C10.5932 8.86837 12.4247 7.1056 14.6732 7.1056C16.9247 7.1056 18.7562 8.87124 18.7562 11.0388C18.7562 13.2064 16.9247 14.972 14.6732 14.972Z",
    fill: "#0985C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    d: "M14.6732 8.2052C13.0531 8.2052 11.7368 9.47703 11.7368 11.0388C11.7368 12.6006 13.0531 13.8725 14.6732 13.8725C16.2933 13.8725 17.6126 12.6006 17.6126 11.0388C17.6126 9.47703 16.2933 8.2052 14.6732 8.2052ZM14.6732 12.4915C13.8423 12.4915 13.1633 11.8398 13.1633 11.036C13.1633 10.235 13.8394 9.58039 14.6732 9.58039C15.5041 9.58039 16.1831 10.2321 16.1831 11.036C16.1831 11.8398 15.5071 12.4915 14.6732 12.4915Z",
    fill: "#0985C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M6.99854 5.04712H2.99893C2.60582 5.04712 2.28418 5.35431 2.28418 5.73615V8.06163C2.28418 8.44346 2.60284 8.75065 2.99893 8.75065H6.99854C7.39165 8.75065 7.71329 8.44346 7.71329 8.06163V5.73615C7.71329 5.35431 7.39463 5.04712 6.99854 5.04712ZM6.28379 7.3726H3.7107V6.42231H6.28379V7.3726Z",
    fill: "#0985C7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1440_500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 19,
    fill: "#0985C7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformacionIcon);
export default __webpack_public_path__ + "static/media/informacion-icon.c07e4db59ceb3a65f42bcfce96cb09fd.svg";
export { ForwardRef as ReactComponent };